<template>
	<div>
		<b-button class="filter" variant="light" block href="#" v-b-toggle.accordion-filter>
			<span><b-icon-funnel-fill></b-icon-funnel-fill> Filter</span>
			<span class="menu-arrow">
				<b-icon-chevron-right class="float-right chevron-right"></b-icon-chevron-right><b-icon-chevron-down class="float-right chevron-down"></b-icon-chevron-down>
			</span>
		</b-button>
		<b-collapse id="accordion-filter" accordion="accordion-filter" role="tabpanel" class="menu-accordion">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="approvalInstances" optionsLabel="approvalTag" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Approval Instance" id="filter-" size="sm" :model.sync="filter.approvalInstanceId" @input="getApprovalInstances" @focus="getApprovalInstances" />
					<app-input-combobox-autocomplete :options="approverTypes" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Approver Type" id="filter-" size="sm" :model.sync="filter.approverTypeId" @input="getApproverTypes" @focus="getApproverTypes" />
					<app-input-combobox-autocomplete :options="approvalStructures" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Approval Structure" id="filter-" size="sm" :model.sync="filter.approvalStructureId" @input="getApprovalStructures" @focus="getApprovalStructures" />
					<app-input-textbox id="fieldset-approver-level" label-cols-sm="4" label-cols-lg="3" label="Approver Level" label-for="filter-approver-level" size="sm" :model.sync="filter.approverLevel" />
					<app-input-textbox id="fieldset-approver-user-name" label-cols-sm="4" label-cols-lg="3" label="Approver User Name" label-for="filter-approver-user-name" size="sm" :model.sync="filter.approverUserName" />
					<app-input-textbox id="fieldset-sequence" label-cols-sm="4" label-cols-lg="3" label="Sequenc" label-for="filter-sequence" size="sm" :model.sync="filter.sequence" />
					<app-input-combobox-autocomplete :options="activityStates" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Activity State" id="filter-" size="sm" :model.sync="filter.acitivtyStateId" @input="getActivityStates" @focus="getActivityStates" />
					<app-input-combobox-autocomplete :options="approvalConfigurationInstanceDetails" optionsLabel="approverType" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Approval Configuration Instance Detail" id="filter-" size="sm" :model.sync="filter.approvalConfigurationInstanceDetailId" @input="getApprovalConfigurationInstanceDetails" @focus="getApprovalConfigurationInstanceDetails" />
					<app-input-textbox id="fieldset-message" label-cols-sm="4" label-cols-lg="3" label="Message" label-for="filter-message" size="sm" :model.sync="filter.message" />
					<app-input-textbox id="fieldset-status" label-cols-sm="4" label-cols-lg="3" label="Status" label-for="filter-status" size="sm" :model.sync="filter.status" />
					<b-button variant="danger" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
					<b-button variant="primary" size="sm" class="float-right mr-1" @click="getApprovalHistorys"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
		</b-collapse>
		<b-row class="mt-3">
			<b-col>
				<b-button variant="warning" v-if="(userRole != null ? userRole.allowUpdate : false)" class="float-right ml-2" @click="showPopupUploadData" size="sm"><b-icon-upload class="mr-1"></b-icon-upload> Upload</b-button>
				<b-overlay
					v-if="(userRole != null ? userRole.allowDownload : false)"
					:show="isDownloadDataBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
					<b-button variant="primary" v-if="(userRole != null ? userRole.allowDownload : false)" class="float-right ml-2" @click="downloadData" size="sm"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>
				</b-overlay>
				<b-button variant="primary" v-if="(userRole != null ? userRole.allowDownload : false)" class="float-right" :href="`files/ApprovalHistory/ApprovalHistory.xlsx`" size="sm"><b-icon-wallet-fill class="mr-1"></b-icon-wallet-fill> Download Template</b-button>
			</b-col>
		 </b-row>
		<b-card class="mt-3">
		<b-row class="mb-3">
			<b-col>
				<b-button variant="success" v-if="(userRole != null ? userRole.allowCreate : false)" to="/approvalhistory/create" size="sm"><b-icon-pencil class="mr-1"></b-icon-pencil> Create</b-button>
				<b-overlay
					v-if="(userRole != null ? userRole.allowPrint : false)"
					:show="isMultiplePrintBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="d-inline-block"
					>
					<b-button variant="primary" v-if="(userRole != null ? userRole.allowPrint : false)" class="ml-2" @click="printData" size="sm"><b-icon-printer-fill class="mr-1"></b-icon-printer-fill> Multiple Print</b-button>
				</b-overlay>
			</b-col>
			<b-col>
				<span class="float-right">
					<b-form-select v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
				</span>
			</b-col>
		</b-row>
		<div class="table-corner">
			<b-table id="my-table" stacked="md" head-variant="head-light"  :no-local-sorting="true" :items="approvalHistorys" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive>
			<template v-slot:head(actions)>
				<b-button-group class="float-right"  size="sm">
					<b-button @click="isShowFilter = !isShowFilter" size="sm"><b-icon-funnel-fill /></b-button>
					<b-button><b-form-checkbox v-if="(userRole != null ? userRole.allowPrint : false)" id="input-select-all" class="float-right" v-model="selectAll"></b-form-checkbox></b-button>
				</b-button-group>
			</template>
			<template #top-row v-if="isShowFilter">
				<b-th></b-th>
				<b-th stacked-heading="Approval Instance">
					<v-select append-to-body label="approvalTag" :options="approvalInstances" :value="filter.approvalInstanceId" :reduce="item => item.id" v-model="filter.approvalInstanceId" :filterable="true" @input="getApprovalHistorysWithoutLoading" @search="getApprovalInstances"></v-select>
				</b-th>
				<b-th stacked-heading="Approver Type">
					<v-select append-to-body label="name" :options="approverTypes" :value="filter.approverTypeId" :reduce="item => item.id" v-model="filter.approverTypeId" :filterable="true" @input="getApprovalHistorysWithoutLoading" @search="getApproverTypes"></v-select>
				</b-th>
				<b-th stacked-heading="Approval Structure">
					<v-select append-to-body label="name" :options="approvalStructures" :value="filter.approvalStructureId" :reduce="item => item.id" v-model="filter.approvalStructureId" :filterable="true" @input="getApprovalHistorysWithoutLoading" @search="getApprovalStructures"></v-select>
				</b-th>
				<b-th stacked-heading="Approver Level">
					<b-form-input id="input-approver-level-table" @input="getApprovalHistorysWithoutLoading" v-model="filter.approverLevel" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Approver User Name">
					<b-form-input id="input-approver-user-name-table" @input="getApprovalHistorysWithoutLoading" v-model="filter.approverUserName" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Sequenc">
					<b-form-input id="input-sequence-table" @input="getApprovalHistorysWithoutLoading" v-model="filter.sequence" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Activity State">
					<v-select append-to-body label="name" :options="activityStates" :value="filter.acitivtyStateId" :reduce="item => item.id" v-model="filter.acitivtyStateId" :filterable="true" @input="getApprovalHistorysWithoutLoading" @search="getActivityStates"></v-select>
				</b-th>
				<b-th stacked-heading="Approval Configuration Instance Detail">
					<v-select append-to-body label="approverType" :options="approvalConfigurationInstanceDetails" :value="filter.approvalConfigurationInstanceDetailId" :reduce="item => item.id" v-model="filter.approvalConfigurationInstanceDetailId" :filterable="true" @input="getApprovalHistorysWithoutLoading" @search="getApprovalConfigurationInstanceDetails"></v-select>
				</b-th>
				<b-th stacked-heading="Message">
					<b-form-input id="input-message-table" @input="getApprovalHistorysWithoutLoading" v-model="filter.message" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Status">
					<b-form-input id="input-status-table" @input="getApprovalHistorysWithoutLoading" v-model="filter.status" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Select All">
					<b-form-checkbox v-if="(userRole != null ? userRole.allowPrint : false)" id="input-select-all" class="float-right d-block d-md-none" v-model="selectAll"></b-form-checkbox>
				</b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
			</template>
			<template v-slot:cell(approvalInstance)="row">
				{{ row.item.approvalInstance != null ? row.item.approvalInstance.approvalTag : "" }}
			</template>
			<template v-slot:cell(approverType)="row">
				{{ row.item.approverType != null ? row.item.approverType.name : "" }}
			</template>
			<template v-slot:cell(approvalStructure)="row">
				{{ row.item.approvalStructure != null ? row.item.approvalStructure.name : "" }}
			</template>
			<template v-slot:cell(acitivtyState)="row">
				{{ row.item.acitivtyState != null ? row.item.acitivtyState.name : "" }}
			</template>
			<template v-slot:cell(approvalConfigurationInstanceDetail)="row">
				{{ row.item.approvalConfigurationInstanceDetail != null ? row.item.approvalConfigurationInstanceDetail.approverType : "" }}
			</template>
			<template v-slot:cell(actions)="row" >
				<div class="div-actions float-right">
				<b-button size="sm" v-if="(userRole != null ? userRole.allowUpdate : false)" :to="{path: '/approvalhistory/edit/' + row.item.id }" variant ="success"  class="mr-2 btn-xs">
					<b-icon-pencil></b-icon-pencil>
				</b-button>
				<b-overlay
					v-if="(userRole != null ? userRole.allowDelete : false)"
					:show="busy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="d-inline-block"
					>
					<click-confirm>
					<b-button size="sm" variant="danger" @click="deleteData(row.item.id)" class="mr-2 btn-xs">
						<b-icon-trash></b-icon-trash>
					</b-button>
					</click-confirm>
				</b-overlay>
				<b-button size="sm" v-if="(userRole != null ? userRole.allowRead : false)" variant="primary" class="mr-2 mt-md-2 mt-lg-0 btn-xs" :to="{path: '/approvalhistory/detail/' + row.item.id }" >
					<b-icon-eye-fill></b-icon-eye-fill>
				</b-button>
				<b-button size="sm" v-if="(userRole != null ? userRole.allowPrint : false)" variant="light"  @click="printSingleData(row.item.id)" class="mr-2 mt-md-2 mt-lg-0 btn-xs">
					<b-icon-printer-fill></b-icon-printer-fill>
				</b-button>
				<b-form-checkbox v-if="(userRole != null ? userRole.allowPrint : false)" class="d-inline" :id="'input-is-print-' + (row.index + 1)" @change="toggleIsPrint(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))" ></b-form-checkbox>
				</div>
			</template>
			</b-table>
		</div>
		<b-row>
			<b-col cols="12" md="6" lg="6">
				<b-button variant="success" v-if="(userRole != null ? userRole.allowCreate : false)" to="/approvalhistory/create" size="sm"><b-icon-pencil class="mr-1"></b-icon-pencil> Create</b-button>
				<b-overlay
					v-if="(userRole != null ? userRole.allowPrint : false)"
					:show="isMultiplePrintBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="d-inline-block"
					>
					<b-button variant="primary" v-if="(userRole != null ? userRole.allowPrint : false)" class="ml-2" @click="printData" size="sm"><b-icon-printer-fill class="mr-1"></b-icon-printer-fill> Multiple Print</b-button>
				</b-overlay>
			</b-col>
			<b-col cols="12" md="6" lg="6">
			<b-pagination
				class="float-md-right btn-paging"
				v-model="currentPage"
				:total-rows="(approvalHistorysPaging != null ? approvalHistorysPaging.dataCount : 0)"
				:per-page="(approvalHistorysPaging != null ? approvalHistorysPaging.pageSize : 0)"
				aria-controls="my-table"
			></b-pagination>
			</b-col>
		</b-row>
		</b-card>
		<Upload
		:openPopup="showPopupUpload"
		@resetMethod="resetModalUpload"
		@uploadButtonMethod="uploadData"
		/>
		<PopupDownload
		:openPopup="showPopupDownload"
		:processId="processId"
		@resetModalMethod="resetModal"
		label= "Popup Download"
		:contentLabel = "popupDownloadLabel"
		/>
		<PopupPDF
		:openPopup="isShowPopupPDF"
		:pdfUrl="pdfUrl"
		@resetModalMethod="resetModal"
		label= "Popup PDF"
		/>
		
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';
</style>
<script>
import ApprovalHistory from '@/models/ApprovalHistory/ApprovalHistory';
import ApprovalHistoryList from '@/models/ApprovalHistory/ApprovalHistoryList';
import ApprovalHistoryFilter from '@/filters/ApprovalHistory/ApprovalHistoryFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputTextarea from '@/components/AppInputTextarea';
import ApprovalInstanceFilter from '@/filters/ApprovalInstance/ApprovalInstanceFilter';
import ApprovalInstance from '@/models/ApprovalInstance/ApprovalInstance';
import ApproverTypeFilter from '@/filters/ApproverType/ApproverTypeFilter';
import ApproverType from '@/models/ApproverType/ApproverType';
import ApprovalStructureFilter from '@/filters/ApprovalStructure/ApprovalStructureFilter';
import ApprovalStructure from '@/models/ApprovalStructure/ApprovalStructure';
import AppInputTextbox from '@/components/AppInputTextbox';
import ActivityStateFilter from '@/filters/ActivityState/ActivityStateFilter';
import ActivityState from '@/models/ActivityState/ActivityState';
import ApprovalConfigurationInstanceDetailFilter from '@/filters/ApprovalConfigurationInstance/ApprovalConfigurationInstanceDetailFilter';
import ApprovalConfigurationInstanceDetail from '@/models/ApprovalConfigurationInstance/ApprovalConfigurationInstanceDetail';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components : {ApprovalHistory, ApprovalHistoryList, ApprovalHistoryFilter, AppInputTextarea,AppInputComboboxAutocomplete,AppInputTextbox,PopupDownload,PopupPDF,Upload,PopupDataEditNotification,},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"no" : { "class" : "th-number"}}, 
				{"approvalInstance": {}, "class" : "th-approval-instance", "label" : "Approval Instance", key: 'approvalInstance', sortable: true}, 
				{"approverType": {}, "class" : "th-approver-type", "label" : "Approver Type", key: 'approverType', sortable: true}, 
				{"approvalStructure": {}, "class" : "th-approval-structure", "label" : "Approval Structure", key: 'approvalStructure', sortable: true}, 
				{"approverLevel": {}, "class" : "th-approver-level", "label" : "Approver Level", key: 'approverLevel', sortable: true}, 
				{"approverUserName": {}, "class" : "th-approver-user-name", "label" : "Approver User Name", key: 'approverUserName', sortable: true}, 
				{"sequence": {}, "class" : "th-sequence", "label" : "Sequenc", key: 'sequence', sortable: true}, 
				{"acitivtyState": {}, "class" : "th-acitivty-state", "label" : "Activity State", key: 'acitivtyState', sortable: true}, 
				{"approvalConfigurationInstanceDetail": {}, "class" : "th-approval-configuration-instance-detail", "label" : "Approval Configuration Instance Detail", key: 'approvalConfigurationInstanceDetail', sortable: true}, 
				{"message": {}, "class" : "th-message", "label" : "Message", key: 'message', sortable: true}, 
				{"status": {}, "class" : "th-status", "label" : "Status", key: 'status', sortable: true}, 
				{"actions": { "class" : "th-actions", "label" : ""}}
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			approvalHistorys: [],
			approvalHistorysPaging: {},
			approvalInstances : [],
			approverTypes : [],
			approvalStructures : [],
			activityStates : [],
			approvalConfigurationInstanceDetails : [],
		}
	},
	methods : {
		getApprovalHistorys : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			ApprovalHistory.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.approvalHistorys = result.data
					this.approvalHistorysPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getApprovalHistorysWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			ApprovalHistory.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.approvalHistorys = result.data
					this.approvalHistorysPaging = result
				}
			})
			.catch(error => {});
		},
		getApprovalInstances : async function(input) {
			let filter = new ApprovalInstanceFilter();
			if (input != undefined) {
				filter.approvalTag = input;
			}
			ApprovalInstance.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalInstances = result.data
				}
			})
			.catch(error => {});
		},
		getApproverTypes : async function(input) {
			let filter = new ApproverTypeFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApproverType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approverTypes = result.data
				}
			})
			.catch(error => {});
		},
		getApprovalStructures : async function(input) {
			let filter = new ApprovalStructureFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalStructure.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalStructures = result.data
				}
			})
			.catch(error => {});
		},
		getActivityStates : async function(input) {
			let filter = new ActivityStateFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ActivityState.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.activityStates = result.data
				}
			})
			.catch(error => {});
		},
		getApprovalConfigurationInstanceDetails : async function(input) {
			let filter = new ApprovalConfigurationInstanceDetailFilter();
			if (input != undefined) {
				filter.approverType = input;
			}
			ApprovalConfigurationInstanceDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalConfigurationInstanceDetails = result.data
				}
			})
			.catch(error => {});
		},
		resetFilter() {
			this.filter = new ApprovalHistoryFilter();
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getApprovalHistorys();
		},
		toggleIsPrint(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				ApprovalHistory.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
					this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			ApprovalHistory.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			if (this.sortBy != null) {
					this.sortingBy[this.sortBy] = this.sortDesc;
			}
			this.isDownloadDataBusy = true;
			ApprovalHistory.downloadData(this, this.filter, this.sortingBy).then(result => {
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			}).catch(error => { this.isDownloadDataBusy = false; })
		},
		deleteData(id) {
			ApprovalHistory.deleteData(this, id).then(result => {
				if (result)
				{
					this.getApprovalHistorys();
				}
			})
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new ApprovalHistoryFilter();
		this.getApprovalInstances()
		this.getApproverTypes()
		this.getApprovalStructures()
		this.getActivityStates()
		this.getApprovalConfigurationInstanceDetails()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Approval History"
		];
		this.getApprovalHistorys();
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
		});
	},
	watch: {
		sortBy: {
			handler: function() {
				this.getApprovalHistorys();
			}
		},
		sortDesc: {
			handler: function() {
				this.getApprovalHistorys();
			}
		},
		currentPage: {
			handler: function() {
				this.getApprovalHistorys();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getApprovalHistorys();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				ApprovalHistory.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "approvalhistoryindex") {
					this.getApprovalHistorysWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "approval_history").first();
		}
	},
	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
